import { createContext, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "./api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null: kontrol ediliyor, false: giriş yok

  useEffect(() => {
    const onLogout = () => setUser(false);
    window.addEventListener("kx-logout", onLogout);
    if (!localStorage.getItem(TOKEN_KEY)) setUser(false);
    else api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    return () => window.removeEventListener("kx-logout", onLogout);
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setUser(r.data.user);
  };
  const logout = () => { localStorage.removeItem(TOKEN_KEY); setUser(false); };
  const can = (...roles) => roles.includes(user?.role);

  return <Ctx.Provider value={{ user, login, logout, can }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
